import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { formatClassName } from '../../Util';

const FilterButton = props => {
  const { label, selected, highlighted } = props;

  return (
    <Button
      className={formatClassName({
        "selected": highlighted,
        "filter-button": true
      })}
      {...props}
      label={selected !== true && selected || label}
      rightIcon="chevron-down"
      style="pill" />
  );
}

FilterButton.propTypes = {
  highlighted: PropTypes.bool,
  label: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default FilterButton;
